import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DataSharingService } from '../../../../auth/data-sharing.service';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
//import { Prevendor } from 'src/app/model/prevendor.model';

import { NgForm } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { TenderingService } from 'src/app/services/tendering/tendering.service';

@Component({
  selector: 'app-enqlistvendor',
  templateUrl: './enqlistvendor.component.html',
  styleUrls: ['./enqlistvendor.component.css']
})
export class EnqlistvendorComponent implements OnInit {

  data: any;

  constructor(private tenderingServices: TenderingService, private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.getEnquiryList();
  }

  getEnquiryList() {
    this.tenderingServices.GetEnquiryQuotesdata().subscribe(
      data => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  submitTechQuote= function (id) {
    //alert(id);
    this.router.navigate(['/submittechquote/' + id + '']);
  }
  submitPriceQuote= function (id) {
    this.router.navigate(['/submitpricequote/' + id + '']);
  }
  submitBoth = function (id) {
    //alert(id);
    this.router.navigate(['/submitpriceandtechquote/' + id + '']);
  }

  enqlistvendorsearch(keyword){
    this.tenderingServices.EnqListVendorSearch(keyword).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
      }
    );

  }
}
